//api.js
import http from './../../http.js'

export const getTrainImages = data => {
	return http({
		url: '/Train/UploadTrainImages',
		method: 'post',
		data
	})
};

export const getAddTrain = data => {
	return http({
		url: '/Train/InsertOrEdit',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		}, //多文件上传这一句必须加
		data
	})
};

export const getTrainRoom = data => {
	return http({
		url: '/Train/GetPageTrainList?pageIndex=' + data.nums + "&pageSize=" + data.size + "&tr_name=" +
			data.tr_name + "&si_guid=" + data.si_guid,
		method: 'get',
	})
};

export const getTrainSingle = data => {
	return http({
		url: '/Train/GetTrainSingle?sx_tr_guid=' + data,
		method: 'get'
	})
};

// 设备电源修改状态

export const TrainPowerEditStatus = data => {
	return http({
		url: '/TrainPower/TrainPowerEditStatus?sx_tp_guid=' + data.sx_tp_guid + "&sx_tp_state=" +
			data.sx_tp_state + "&ui_guid=" + data.ui_guid + "&sx_tr_name=" + data.sx_tr_name,
		method: 'get'
	})
};

export const getTrainEquipmentList = data => {
	return http({
		url: '/TrainEquipment/GetTrainEquipmentList?sx_tr_guid=' + data.sx_tr_guid + "&te_deviceName=" +
			data.te_deviceName + "&si_guid=" + data.si_guid,
		method: 'get'
	})
};
// 设备不分页

export const GetbfyTrainEquipmentLists = data => {
	return http({
		url: '/TrainEquipment/GetTrainEquipmentList?si_guid=' + data,
		method: 'get'
	})
};
// 实训室不分页
export const getbfyGetTrainList = data => {
	return http({
		url: '/Train/GetTrainList?si_guid=' + data,
		method: 'get'
	})
};

// 实训室修改图片

export const TrainEditTrainImages = data => {
	return http({
		url: '/Train/EditTrainImages',
		method: 'post',
		data
	})
};

// 删除实训室的图片

export const TrainDeleteTrainPic = data => {
	return http({
		url: '/Train/DeleteTrainPic?sx_tp_guid=' + data,
		method: 'get'

	})
};

// 批量删除实训室
export const TrainDeleteList = data => {
	return http({
		url: '/Train/DeleteList',
		method: 'post',
		data
	})
};

// 删除实训室图片
export const postDeleteImages = data => {
	return http({
		url: '/Train/DeleteTrainImage',
		method: 'post',
		data
	})
};
// 删除实训设备图片
export const DeleteTrainEquipmentImages = data => {
	return http({
		url: '/TrainEquipment/DeleteTrainEquipmentImages',
		method: 'post',
		data
	})
};



// 实训设备

export const getPageTrainEquipmentList = data => {
	return http({
		url: '/TrainEquipment/GetPageTrainEquipmentList?pageIndex=' + data.pageIndex + "&pageSize=" +
			data.pageSize + "&si_guid=" + data.si_guid + "&sx_tr_guid=" + data.sx_tr_guid +
			"&te_deviceName=" + data.te_deviceName,
		method: 'get'
	})
};


export const getTrainEquipmentSingle = data => {
	return http({
		url: '/TrainEquipment/GetTrainEquipmentSingle?sx_te_guid=' + data,
		method: 'get'
	})
};

// 设备电源操作记录
export const getPageTrainPowerLogList = data => {
	return http({
		url: '/TrainPower/GetPageTrainPowerLogList?pageIndex=' + data.pageIndex + "&pageSize=" + data
			.pageSize + "&sx_tpl_name=" + data.sx_tpl_name + "&sx_tpl_number=" + data.sx_tpl_number,
		method: 'get'
	})
};

// 删除实训室

export const getdgPageTrainDelete = data => {
	return http({
		url: '/Train/Delete?sx_tr_guid=' + data.sx_tr_guid + "&isDelete=" + data.isDelete,
		method: 'get'
	})
};

// 实现设备更改
export const getUpdatetrainsb = data => {
	return http({
		url: '/TrainEquipment/Update',
		method: 'post',
		data
	})
};

// 实训设备上传图片
export const TrainEquipmentUploadImages = data => {
	return http({
		url: '/TrainEquipment/UploadImages',
		method: 'post',
		data
	})
};

// 实训子设备
export const GetTrainEquipmentChildList = data => {
	return http({
		url: '/TrainEquipment/GetTrainEquipmentChildList?sx_te_guid=' + data,
		method: 'get'
	})
};

// 上传实训室图片
export const TrainUploadTrainImages = data => {
	return http({
		url: '/Train/UploadTrainImages',
		method: 'post',
		data
	})
};


// 添加子设备
export const GetTrainInsert = data => {
	return http({
		url: '/TrainEquipment/Insert',
		method: 'post',
		data
	})
};

// 删除单条涉笔

export const GetTrainEquipmentDeletesb = data => {
	return http({
		url: '/TrainEquipment/Delete?sx_te_guid=' + data.sx_te_guid + "&isdelete=" + data.isdelete,
		method: 'get'
	})
};

// 实训电源

export const GetdyPageTrainPowerList = data => {
	return http({
		url: '/TrainPower/GetPageTrainPowerList?pageIndex=' + data.pageIndex + "&pageSize=" + data
			.pageSize + "&sx_tp_name=" + data.sx_tp_name + "&sx_tp_number=" + data.sx_tp_number +
			"&sx_tr_guid=" + data.sx_tr_guid + "&si_guid=" + data.si_guid,
		method: 'get'
	})
};


// 修改可预约的时间
export const InsertsbOrEditTrainingSet = data => {
	return http({
		url: '/TrainEquipment/InsertOrEditTrainingSet',
		method: 'post',
		data
	})
};
// 修改可预约时间
export const InsertOrEditTrainingroomSet = data => {
	return http({
		url: '/Train/InsertOrEditTrainingroomSet',
		method: 'post',
		data
	})
};
export const GetTrainingroomSetSingle = data => {
	return http({
		url: '/Train/GetTrainingroomSetSingle?sx_tr_guid=' + data,
		method: 'get'

	})
};


export const GetscTrainingSetSingle = data => {
	return http({
		url: '/TrainEquipment/GetTrainingSetSingle?sx_te_guid=' + data,
		method: 'get'
	})
};

// 一键开启或者一键关闭电源


export const AllTrainPowerEditStatus = data => {
	return http({
		url: '/TrainPower/AllTrainPowerEditStatus?sx_tr_guid=' + data.sx_tr_guid + "&sx_tp_state=" + data
			.sx_tp_state + "&ui_guid=" + data.ui_guid,
		method: 'get'
	})
};

// 删除设备

export const TrainPowerDelete = data => {
	return http({
		url: '/TrainPower/Delete?sx_tp_guid=' + data,
		method: 'get'
	})
};

// 上传电源图片

export const TrainPowerUploadImages = data => {
	return http({
		url: '/TrainPower/UploadImages',
		method: 'post',
		data
	})
};


// 获取单个电源

export const GetTrainPowerSingle = data => {
	return http({
		url: '/TrainPower/GetTrainPowerSingle?sx_tp_guid=' + data,
		method: 'get'
	})
};



export const GetTrainEquipmentInsert = data => {
	return http({
		url: '/TrainEquipment/Insert',
		method: 'post',
		data
	})
};


// 添加电源
export const GetTrainPowerInsertOrEdit = data => {
	return http({
		url: '/TrainPower/InsertOrEdit',
		method: 'post',
		data
	})
};


// 查询日历可预约时间实训设备
export const GetAppointmentCount = data => {
	return http({
		url: '/Appointment/GetAppointmentCount?sx_te_guid=' + data,
		method: 'get'
	})
};
// 查询日历可预约时间实训室

export const GetAppointmentroomCount = data => {
	return http({
		url: '/Appointment/GetAppointmentroomCount?sx_te_guid=' + data,
		method: 'get'
	})
};


// 查询日历可预约时间
export const getUserAppointment = data => {
	return http({
		url: '/Appointment/UserAppointment',
		method: 'post',
		data
	})
};



// 根据日期实训设备配置  /Train/GetSetting
export const TrainGetSetting = data => {
	return http({
		url: '/Train/GetSetting?sx_tr_guid=' + data.sx_tr_guid + "&app_time=" + data.app_time,
		method: 'get'
	})
};


// 根据日期实训设备配置  /Train/GetSetting
export const TrainEquipmentGetSetting = data => {
	return http({
		url: '/TrainEquipment/GetSetting?sx_te_guid=' + data.sx_te_guid + "&app_time=" + data.app_time,
		method: 'get'
	})
};